import { UploadProfileImageResponse } from "../../../@types/Users";
import { api } from "../../api";

export default async function uploadProfileImage(
  formData: FormData
): Promise<UploadProfileImageResponse | null> {
  try {
    const { data } = await api.post("/user/upload-image", formData);

    return data;
  } catch (err: any) {
    const status = err?.response?.status;
    const data = err?.response?.data;

    if (status === 400) {
      return data;
    }
    return null;
  }
}
